import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DailyReward, Reward } from '@/core/interfaces';

interface RewardsState {
	rewards: Reward[];
	youtubeRewards: Reward[];
	dailyRewards: DailyReward[];
}

const rewardsSlice = createSlice({
	name: 'rewards',
	initialState: {
		rewards: [],
		dailyRewards: [],
		youtubeRewards: [],
	} as RewardsState,
	reducers: {
		setRewards: (state, action: PayloadAction<Reward[]>) => {
			state.rewards = action.payload;
		},
		setYoutubeRewards: (state, action: PayloadAction<Reward[]>) => {
			state.youtubeRewards = action.payload;
		},
		setDailyRewards: (state, action: PayloadAction<DailyReward[]>) => {
			state.dailyRewards = action.payload;
		},
	},
});

const { reducer, actions } = rewardsSlice;

export const { setRewards, setDailyRewards, setYoutubeRewards } = actions;
export default reducer;
